var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-add",attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.evOnClick}},[_c('i',{staticClass:"fas fa-plus mr-2 text-twenty"}),_vm._v(" "+_vm._s(_vm.loading ? "CARREGANDO" : _vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }